<template>
    <v-container>
        <v-data-table :headers="headers" :items="items" :search="search" class="elevation-1">
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>Investicie</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                        hide-details></v-text-field>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="dialog" max-width="500px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                                Nova investicia
                            </v-btn>
                        </template>
                        <v-card>
                            <v-card-title>
                                <span class="text-h5">{{ formTitle }}</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field v-model="editedItem.contract_number"
                                                label="Contract Number"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field v-model="editedItem.user" label="Pouzivatel"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field v-model.number="editedItem.investment_amount"
                                                label="Suma investicie" type="number"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field v-model.number="editedItem.coefficient" label="Koeficient"
                                                type="number"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field v-model.number="editedItem.payout_claim" label="Narok"
                                                type="number"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-checkbox v-model="editedItem.status" label="Aktivne"></v-checkbox>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="close">Zrusit</v-btn>
                                <v-btn color="blue darken-1" text @click="save">Ulozit</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
                <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
            </template>
            <template v-slot:item.status="{ item }">
                <v-chip :color="item.status ? 'green' : 'red'" dark>{{ item.status ? 'Active' : 'Inactive' }}</v-chip>
            </template>
        </v-data-table>

        <v-dialog v-model="deleteDialog" max-width="500px">
            <v-card>
                <v-card-title class="text-h6">Potvrdenie vymazania</v-card-title>
                <v-card-text>
                    Naozaj chcete vymazať investíciu
                    <strong v-if="deleteItemTarget && deleteItemTarget.contract_number">
                        #{{ deleteItemTarget.contract_number }}
                    </strong>
                    <strong v-else-if="deleteItemTarget">
                        #{{ deleteItemTarget.id }}
                    </strong>
                    ? Táto akcia sa nedá vrátiť späť.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="closeDeleteDialog">Zrušiť</v-btn>
                    <v-btn color="error" :loading="deleting" @click="confirmDeleteItem">Vymazať</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="6000">
            {{ snackbar.message }}
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar.show = false">Zavrieť</v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>

<script>
import { APIService } from "@/http/APIService.js";
const apiService = new APIService();

export default {
    data: () => ({
        dialog: false,
        deleteDialog: false,
        deleting: false,
        deleteItemTarget: null,
        search: '',
        snackbar: {
            show: false,
            message: '',
            color: 'success'
        },
        headers: [
            { text: 'ID', value: 'id' },
            { text: 'Cislo zmluvy', value: 'contract_number' },
            { text: 'Pouzivatel', value: 'user' },
            { text: 'Suma investicie', value: 'investment_amount' },
            { text: 'Koeficient', value: 'coefficient' },
            { text: 'Narok', value: 'payout_claim' },
            { text: 'Status', value: 'status' },
            { text: 'Vytvorene', value: 'created_at' },
            { text: 'Akcie', value: 'actions', sortable: false },
        ],
        items: [],
        editedIndex: -1,
        editedItem: {
            contract_number: '',
            user: null,
            investment_amount: 0,
            coefficient: 0,
            payout_claim: 0,
            status: false,
        },
        defaultItem: {
            contract_number: '',
            user: null,
            investment_amount: 0,
            coefficient: 0,
            payout_claim: 0,
            status: false,
        },
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? 'New Investment' : 'Edit Investment';
        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
    },

    created() {
        this.initialize();
    },

    methods: {
        initialize() {
            apiService.getAdminInvestments('', '', 100, 0).then(response => {
                this.items = response.results;
            });
        },

        editItem(item) {
            this.editedIndex = this.items.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },

        deleteItem(item) {
            this.deleteItemTarget = item;
            this.deleteDialog = true;
        },

        closeDeleteDialog() {
            this.deleteDialog = false;
            this.$nextTick(() => {
                this.deleteItemTarget = null;
            });
        },

        showSnackbar(message, color = 'success') {
            this.snackbar.message = message;
            this.snackbar.color = color;
            this.snackbar.show = true;
        },

        confirmDeleteItem() {
            if (!this.deleteItemTarget || !this.deleteItemTarget.id) {
                this.closeDeleteDialog();
                return;
            }

            const itemId = this.deleteItemTarget.id;
            this.deleting = true;

            apiService.deleteInvestment(itemId).then(() => {
                this.initialize();
                this.showSnackbar('Investícia bola úspešne vymazaná.', 'success');
                this.closeDeleteDialog();
            }).catch((error) => {
                const statusCode = error && error.response ? error.response.status : null;

                if (statusCode === 403) {
                    this.showSnackbar('Nemáte oprávnenie na vymazanie tejto investície.', 'error');
                    return;
                }

                if (statusCode === 404) {
                    this.initialize();
                    this.showSnackbar('Investícia už neexistuje. Zoznam bol obnovený.', 'warning');
                    this.closeDeleteDialog();
                    return;
                }

                this.showSnackbar('Investíciu sa nepodarilo vymazať. Skúste to znova.', 'error');
            }).finally(() => {
                this.deleting = false;
            });
        },

        close() {
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },

        save() {
            if (this.editedIndex > -1) {
                apiService.updateAdminInvestment(this.editedItem).then(() => {
                    this.initialize();
                });
            } else {
                apiService.createAdminInvestment(this.editedItem).then(() => {
                    this.initialize();
                });
            }
            this.close();
        },
    },
};
</script>